import axios from "../axios";

/**
 * 5.1 工单列表
 * POST /as-web/api/v1/workorders/list
 */
export const list = (data) => {
  return axios({
    url: "workorders/list",
    method: "post",
    data,
  });
};

/**
 * 5.2 工单详情
 * POST /as-web/api/v1/workorders/detail
 */
export const detail = (data) => {
  return axios({
    url: "workorders/detail",
    method: "post",
    data,
  });
};

/**
 * 5.3 地图分布
 * POST /as-web/api/v1/workorders/map
 */
export const map = (data) => {
  return axios({
    url: "workorders/map",
    method: "post",
    data,
  });
};

/**
 * 5.4 提单统计（按设备）
 * POST /as-web/api/v1/workorders/stats
 */
export const stats = (data) => {
  return axios({
    url: "workorders/stats",
    method: "post",
    data,
  });
};

/**
 * 5.5 接单排名
 * POST /as-web/api/v1/workorders/staff-rank
 */
export const staffRank = (data) => {
  return axios({
    url: "workorders/staff-rank",
    method: "post",
    data,
  });
};
